"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _md = _interopRequireDefault(require("md5"));

var _fields = _interopRequireDefault(require("./fields"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function forEachSeries(_x, _x2, _x3) {
  return _forEachSeries.apply(this, arguments);
}

function _forEachSeries() {
  _forEachSeries = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(array, cb, done) {
    var wrap, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            wrap = function wrap(item) {
              return new Promise(function (resolve, reject) {
                cb(item, function (e) {
                  if (e) {
                    reject();
                  }

                  resolve();
                });
              });
            };

            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context.prev = 4;
            _iterator = array[Symbol.iterator]();

          case 6:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context.next = 19;
              break;
            }

            item = _step.value;
            _context.prev = 8;
            _context.next = 11;
            return wrap(item);

          case 11:
            _context.next = 16;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](8);
            return _context.abrupt("return", done(_context.t0));

          case 16:
            _iteratorNormalCompletion = true;
            _context.next = 6;
            break;

          case 19:
            _context.next = 25;
            break;

          case 21:
            _context.prev = 21;
            _context.t1 = _context["catch"](4);
            _didIteratorError = true;
            _iteratorError = _context.t1;

          case 25:
            _context.prev = 25;
            _context.prev = 26;

            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
              _iterator["return"]();
            }

          case 28:
            _context.prev = 28;

            if (!_didIteratorError) {
              _context.next = 31;
              break;
            }

            throw _iteratorError;

          case 31:
            return _context.finish(28);

          case 32:
            return _context.finish(25);

          case 33:
            done(null);

          case 34:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 21, 25, 33], [8, 13], [26,, 28, 32]]);
  }));
  return _forEachSeries.apply(this, arguments);
}

function init() {
  return new Promise(function (resolve, reject) {
    reg('std_msgs/String', 'string data\n', function (e) {
      if (e) {
        reject(e);
      }

      resolve();
    });
  });
}

function reg(messageType, content, callback) {
  // const messageType = 'std_msgs/String';
  // const content = 'string data\n';
  var packageName = getPackageNameFromMessageType(messageType);
  var messageName = getMessageNameFromMessageType(messageType);
  var details = {
    messageType: messageType,
    messageName: messageName,
    packageName: packageName,
    content: content,
    constants: null,
    fields: null,
    md5: null
  };
  extractFields(content, details, function (error, constants, fields) {
    if (error) {
      callback(error);
    } else {
      details.constants = constants;
      details.fields = fields;
      details.md5 = calculateMD5(details);
      var message = buildMessageClass(details);
      setMessageInRegistry(messageType, message);
      callback(null);
    }
  });
}

function getMessage(messageType) {
  return new Promise(function (resolve, reject) {
    var packageName = getPackageNameFromMessageType(messageType);
    var messageName = getMessageNameFromMessageType(messageType);
    getMessageFromPackage(packageName, messageName, function (e, m) {
      if (e) {
        reject(e);
      }

      resolve(m);
    });
  });
}

function getMessageFromPackage(packageName, messageName, callback) {
  var messageType = getMessageType(packageName, messageName);
  var message = getMessageFromRegistry(messageType);

  if (message) {
    callback(null, message);
  } else {
    callback('Not found type message ' + packageName + '/' + messageName);
  }
}

function calculateMD5(details) {
  var message = '';
  message += details.constants.map(function (field) {
    return field.type + ' ' + field.name + '=' + field.value;
  }).join('\n');
  message += details.fields.map(function (field) {
    if (field.messageType) {
      return field.messageType.md5 + ' ' + field.name;
    } else {
      return field.type + ' ' + field.name;
    }
  }).join('\n');
  return (0, _md["default"])(message);
}

function extractFields(content, details, callback) {
  var constants = [];
  var fields = [];

  var parseLine = function parseLine(line, callback) {
    line = line.trim();
    var lineEqualIndex = line.indexOf('=');
    var lineCommentIndex = line.indexOf('#');

    if (lineEqualIndex === -1 || lineCommentIndex === -1 || lineEqualIndex >= lineCommentIndex) {
      line = line.replace(/#.*/, '');
    }

    if (line === '') {
      callback();
    } else {
      var firstSpace = line.indexOf(' ');
      var field = line.substring(firstSpace + 1);
      var equalIndex = field.indexOf('=');
      var fieldType = line.substring(0, firstSpace);
      var fieldName = field.trim();

      if (equalIndex !== -1) {
        fieldName = field.substring(0, equalIndex).trim();
        var constant = field.substring(equalIndex + 1, field.length).trim();

        var parsedConstant = _fields["default"].parsePrimitive(fieldType, constant);

        constants.push({
          name: fieldName,
          type: fieldType,
          value: parsedConstant,
          index: fields.length,
          messageType: null
        });
        callback();
      } else {
        if (_fields["default"].isPrimitive(fieldType)) {
          fields.push({
            name: fieldName.trim(),
            type: fieldType,
            index: fields.length,
            messageType: null
          });
          callback();
        } else if (_fields["default"].isArray(fieldType)) {
          var arrayType = _fields["default"].getTypeOfArray(fieldType);

          if (_fields["default"].isMessage(arrayType)) {
            fieldType = normalizeMessageType(fieldType, details.packageName);
            arrayType = normalizeMessageType(arrayType, details.packageName);
            getMessage(arrayType, function (error, messageType) {
              fields.push({
                name: fieldName.trim(),
                type: fieldType,
                index: fields.length,
                messageType: messageType
              });
              callback();
            });
          } else {
            fields.push({
              name: fieldName.trim(),
              type: fieldType,
              index: fields.length,
              messageType: null
            });
            callback();
          }
        } else if (_fields["default"].isMessage(fieldType)) {
          fieldType = normalizeMessageType(fieldType, details.packageName);
          getMessage(fieldType, function (error, messageType) {
            fields.push({
              name: fieldName.trim(),
              type: fieldType,
              index: fields.length,
              messageType: messageType
            });
            callback();
          });
        }
      }
    }
  };

  var lines = content.split('\n');
  forEachSeries(lines, parseLine, function (error) {
    if (error) {
      callback(error);
    } else {
      callback(null, constants, fields);
    }
  });
}

var registry = {};

function getMessageFromRegistry(messageType) {
  return registry[messageType];
}

function setMessageInRegistry(messageType, message) {
  registry[messageType] = message;
}

function getMessageType(packageName, messageName) {
  return packageName ? packageName + '/' + messageName : messageName;
}

function getPackageNameFromMessageType(messageType) {
  return messageType.indexOf('/') !== -1 ? messageType.split('/')[0] : '';
}

function normalizeMessageType(messageType, packageName) {
  var normalizedMessageType = messageType;
  var isNormalizedMessageType = /.*\/.*$/;

  if (messageType.match(isNormalizedMessageType) === null) {
    normalizedMessageType = getMessageType(packageName, messageType);
  }

  return normalizedMessageType;
}

function getMessageNameFromMessageType(messageType) {
  return messageType.indexOf('/') !== -1 ? messageType.split('/')[1] : messageType;
}

function buildMessageClass(details) {
  function Message(values) {
    var _this = this;

    if (details.constants) {
      details.constants.forEach(function (field) {
        _this[field.name] = field.value || null;
      });
    }

    if (details.fields) {
      details.fields.forEach(function (field) {
        _this[field.name] = field.value || null;
      });
    }

    if (values) {
      Object.keys(values).forEach(function (name) {
        _this[name] = values[name];
      });
    }
  }

  Message.prototype.getMessageSize = function (msg) {
    return Buffer.byteLength(msg.data, 'utf8') + 4;
  };

  Message.prototype.serialize = function (msg, buffer, bufferOffset) {
    function getByteLength(strValue) {
      return Buffer.byteLength(strValue, 'utf8');
    }

    function StringSerializer(value, buffer, bufferOffset) {
      var len = getByteLength(value);
      bufferOffset = buffer.writeUInt32LE(len, bufferOffset);
      return bufferOffset + buffer.write(value, bufferOffset, len, 'utf8');
    }

    return StringSerializer(msg.data, buffer, bufferOffset);
  };

  Message.prototype.messageDefinition = details.content;
  Message.prototype.messageType = details.messageType;
  Message.prototype.packageName = details.packageName;
  Message.prototype.messageName = details.messageName;
  Message.prototype.md5 = details.md5;
  Message.prototype.constants = details.constants;
  Message.prototype.fields = details.fields;
  return Message;
}

var _default = {
  init: init,
  reg: reg,
  getMessage: getMessage
};
exports["default"] = _default;